// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1STHr","container":"styles_container__1LF_R","title":"styles_title__2n1n7","wrapper":"styles_wrapper__19WW3","answer":"styles_answer__5dpsj"};